module.exports = __webpack_public_path__ + "img/maduo4.51e973f5.jpg";